import React, { useState } from 'react';
import ResultCard from './ResultCard';
import SeeMoreModal from './ResultFull';
import axios from 'axios';

const SearchResults = ({ recipes }) => {
  const [open, setOpen] = useState(false);
  const [recipe, setRecipe] = useState({});

  const recipeUrl = 'https://api.spoonacular.com/recipes/';

  const handleClickOpen = (id) => {
    axios
      .get(
        recipeUrl + id + '/information?apiKey=1b4fe65ddf444934a7383294bdc90f6e'
      )
      .then((res) => {
        const recipe = res.data;
        setRecipe(recipe);
        setOpen(true);
        console.log(recipe);
      })
      .catch((err) => console.error(err));
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className="card-list">
      {!!recipes &&
        recipes.map((result) => {
          return (
            <ResultCard
              key={result.id}
              result={result}
              handleClickOpen={handleClickOpen}
            />
          );
        })}
      {open && <SeeMoreModal recipe={recipe} handleClose={handleClose} />}
      {open && <div className="modal-overlay"></div>}
    </div>
  );
};

export default SearchResults;
